function formatCurrencyAfter(amount) {
  return Shopify.formatMoney(amount)
}
class CartTotalUpdater {
  constructor() {
    this.cartTotalElement = document.querySelector('[data-cart-total]');
    this.setupEventListeners();
    this.initQuantityButtons();
    const currentCartState = localStorage.getItem('cart-status').trim();
    if (currentCartState === CART_STATUS.MAINTENANCE || currentCartState === CART_STATUS.NORMAL_MAINTENANCE) {
      this.cartTotalElement.innerHTML = `Total: ${formatCurrencyAfter(localStorage.getItem('total-price'))}`;
    }
  }

  setupEventListeners() {
    document.addEventListener('product:added', this.updateCartTotal.bind(this));
    document.addEventListener('cart:update', this.updateCartTotal.bind(this));
    document.addEventListener('cart:remove', this.updateCartTotal.bind(this));
    document.addEventListener('cart:refresh', this.updateCartTotal.bind(this));

    const cartForms = document.querySelectorAll('form[action="/cart/add"]');
    cartForms.forEach(form => {
      form.addEventListener('submit', () => {
        setTimeout(() => this.updateCartTotal(), 200);
      });
    });


    document.addEventListener('change', (event) => {
      if (event.target.matches('[name="quantity"], [name="updates[]"]')) {
        // setTimeout(() => this.updateCartTotal(), 200);
      }
    });

    this.updateCartTotal();
  }

  initQuantityButtons() {

    // document.addEventListener('click', (event) => {
    //   if (event.target.matches('.quantity__button')) {
    //     setTimeout(() => this.updateCartTotal(), 200);
    //   }

    //   if (event.target.closest('cart-remove-button') ||
    //     event.target.closest('.button--tertiary')) {
    //     setTimeout(() => this.updateCartTotal(), 200);
    //   }
    // });

    // document.addEventListener('change', (event) => {
    //   if (event.target.matches('.quantity__input')) {
    //     setTimeout(() => this.updateCartTotal(), 200);
    //   }
    // });
  }

  updateCartTotal() {
    const postcodeElement = document.querySelector('[data-customer-postcode]');
    const postcode = postcodeElement ? postcodeElement.getAttribute('data-customer-postcode').replace(/-/g, '') : null;
    const loggedIn = document.querySelector("#loginState")?.value == 'logged' ? 'true' : null;

    fetch('/cart.js', { credentials: 'include' })
      .then(response => response.json())
      .then(cart => {
        if (this.cartTotalElement) {
          const currentCartState = localStorage.getItem('cart-status').trim();
          if (currentCartState === CART_STATUS.MAINTENANCE || currentCartState === CART_STATUS.NORMAL_MAINTENANCE) {
            this.cartTotalElement.innerHTML = `Total: ${formatCurrencyAfter(localStorage.getItem('total-price'))}`;
            const lineItems = cart.items.map(item => {
              const installationQuantity = item.properties['Installation Quantity'] ?? 0;
              return {
                installationQuantity: Number(installationQuantity),
                variantId: `${item.variant_id}`,
                variantQuantity: item.quantity,
              }
            })
            const loggedIn = document.querySelector("#loginState")?.value == 'logged' ? 'true' : null;

            const body = JSON.stringify({ lineItems, postcode, loggedIn });
            fetch(`${window.appDomain}/maintenance/cart`, {
              method: 'POST',
              headers: {
                "Content-Type": "application/json"
              },
              body,
            })
              .then((response) => {
                return response.json();
              }).then((data) => {
                const { subtotal } = data.result.data
                var total = subtotal.totalPrice;
                // if (loggedIn) {
                //   // total - 10%
                //   total = total * 0.9;
                // }
                localStorage.setItem('total-price', total * 100);
                const formattedPrice = formatCurrencyAfter(total * 100);
                this.cartTotalElement.innerHTML = `Total: ${formattedPrice}`;
              })
          } else {
            const customTotalPrice = document.querySelector("#customTotalPrice")?.value || 0;
            const formattedPrice = Shopify.formatMoney(customTotalPrice);
            this.cartTotalElement.innerHTML = `Total: ${formattedPrice}`;
          }
        }
      })
      .catch(error => console.error('Error fetching cart:', error));
  }


}

new CartTotalUpdater();